interface Props {
  isOnline: boolean;
  queueLength: number;
  syncing: boolean;
}

export default function OfflineIndicator({ isOnline, queueLength, syncing }: Props) {
  if (isOnline && queueLength === 0) return null;

  return (
    <div
      style={{
        background: isOnline ? '#f39c12' : '#e74c3c',
        color: 'white',
        padding: '6px 12px',
        textAlign: 'center',
        fontSize: '0.85em',
        fontWeight: 'bold',
      }}
    >
      {!isOnline && '📡 Hors ligne — les modifications seront synchronisées à la reconnexion'}
      {isOnline && syncing && '🔄 Synchronisation en cours...'}
      {isOnline && !syncing && queueLength > 0 && `⚠ ${queueLength} requête(s) en attente de synchronisation`}
    </div>
  );
}
